import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getProjects = (featured) =>
  api.get("/projects", { params: featured ? { featured: true } : {} }).then((r) => r.data);
export const getProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
